import Vue from 'vue';
import Component from 'vue-class-component';
import { G2S } from 'core/g2s';
import { Prop } from 'vue-property-decorator';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

interface Market {
    code: string;
    url: string;
    name: string;
    nameNative: string;
    currency: string;
    currencySymbol: string;
}

@WithRender
@Component
export class SwitchLanguageComponent extends Vue {
    @Prop()
    markets: Market[]; 

    @Prop()
    currentMarket: any;
    
    @Prop()
    isMenuAdditional: boolean;
    
    currencyValue: string = '';
    languageValue: string = '';
    marketCode: string = '';
    gaClientID: string = '';    
    
    get currency() {
        return this.currencyValue;
    }

    get language() {
        return this.languageValue;
    }

    get filteredMarkets() {
        return this.markets; // Для ограничений маркета со стороны vue
    }

    mounted() {
        this.gaClientID = utils.Cookies.getGaClientId();
        this.marketCode = G2S.config.marketCode;
    }

    openLanguageModal() {
        (<any>this).$refs.languageModal.show();
    }

    getCurrencySymbol(code) {
        return utils.String.currencySymbol(code);
    }

    setCurrency(newValue: string) {
        this.currencyValue = newValue;
    }

    changeCurrentMarket(market) {
        if(this.isMenuAdditional){
            this.$emit('on-change', market);
            (<any>this).$refs.languageModal.hide();
        }else {
            this.onApply(market.code);
        }
    }

    setLanguage(newValue: string) {
        this.languageValue = newValue;
    }

    onOpenDropdow() {
        (<any>this).$ga.sendEvent('market', 'open.dropdown', 'market.open.dropdown');
    }
    
    onApply(code) {
        location.href = location.protocol+ '//' + code + '-' + 'm.' + G2S.config.cookieDomain + location.pathname;
    }
}